import React from 'react'
import {connect} from 'react-redux'
import {setNavSearch} from '../../../../redux/modules/ui'
import SearchCard from '../components/SearchCard'
import {selectUserInfo} from '../../../../redux/modules/session'
import {isScrolledIntoView} from '../../../../util/ScrollTo'


class VisibleSearchHeaderComponent extends React.PureComponent {

  constructor(props) {
    super(props)
    this.headerSearchBar = null
    this.state = {
      ticking: false
    }
    this.onScroll = this.onScroll.bind(this)
  }
  componentDidMount() {
    this.headerSearchBar = document.getElementById('search-header-search')
    window.addEventListener('scroll', this.onScroll, false)
    this.onScroll()
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll, false)
    this.props.setNavSearch(false)
  }
  onScroll() {
    if (!this.state.ticking) {
      window.requestAnimationFrame(() => {
        const status = !isScrolledIntoView(this.headerSearchBar)
        if (status !== this.props.navSearchEnabled) {
          this.props.setNavSearch(status)
        }
        this.setState({
          ticking: false
        })
      })
      this.setState({
        ticking: true
      })
    }
  }
  render() {
    return (
      <SearchCard {...this.props} />
    )
  }
}

const mapStateToProps = state => {
  const userInfo = selectUserInfo(state)
  return {
    navSearchEnabled: state.getIn(['ui','navSearchEnabled']),
    isLoggedIn: userInfo.isLoggedIn,
    displayName: userInfo.user.has('displayName') ? userInfo.user.get('displayName') : ''
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setNavSearch: (isOn) => dispatch(setNavSearch(isOn))
  }
}

const VisibleSearchHeader = connect(
  mapStateToProps,
  mapDispatchToProps
)(VisibleSearchHeaderComponent)

export default VisibleSearchHeader



// WEBPACK FOOTER //
// ./src/domains/home/subjects/containers/VisibleSearchHeader.js